import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { forexApi, type MasterSignalListItem } from "@/lib/forex-api";

const date = (value: number) => new Date(value * 1000).toLocaleString("zh-CN", { hour12: false });

export default function ExecutionDetailTab() {
  const [params, setParams] = useSearchParams();
  const agentId = params.get("agent_id") || "";
  const [agentFilter, setAgentFilter] = useState(agentId);
  const [signals, setSignals] = useState<MasterSignalListItem[]>([]);
  const [cursor, setCursor] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    setLoading(true); setCursor(null); setSignals([]);
    forexApi.listStrategySignals(agentId || undefined)
      .then((result) => { if (active) { setSignals(result.items); setCursor(result.next_cursor); } })
      .catch(() => { if (active) setError("共享信号加载失败，请刷新重试"); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [agentId]);
  const loadMore = async () => {
    if (!cursor || loading) return;
    setLoading(true); setError("");
    try {
      const page = await forexApi.listStrategySignals(agentId || undefined, cursor);
      setSignals((items) => [...items, ...page.items]);
      setCursor(page.next_cursor);
    } catch { setError("下一页信号加载失败，请重试"); }
    finally { setLoading(false); }
  };

  return <div className="space-y-4">
    <div><h2 className="text-lg font-semibold">信号与执行</h2>
      <p className="text-xs text-text-muted">每条策略信号对应独立的账号目标；打开详情核对各账号的准入、命令和 Broker 回报。</p></div>
    <form className="flex gap-2" onSubmit={(event) => { event.preventDefault();
      setParams(agentFilter.trim() ? { agent_id: agentFilter.trim() } : {}); }}>
      <input aria-label="智能体筛选" value={agentFilter} onChange={(event) => setAgentFilter(event.target.value)}
        className="rounded-lg border px-3 py-2 text-xs" placeholder="按智能体编号筛选" />
      <button type="submit" className="rounded-lg border px-3 py-2 text-xs">筛选</button>
    </form>
    {error && <p role="alert" className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">{error}</p>}
    {loading && <p className="text-sm text-text-muted">加载中...</p>}
    {!loading && !signals.length && !error && <p className="rounded-lg border bg-white p-5 text-sm text-text-muted">暂无已生成的交易信号。HOLD 和无信号运行可在决策记录中查看。</p>}
    {!!signals.length && <p className="text-xs text-text-muted">已加载 {signals.length} 条共享信号{cursor ? " · 仍有后续页" : ""}；是否成交以逐账号回报和核对为准</p>}
    {!!signals.length && <div className="overflow-x-auto rounded-lg border bg-white"><table className="w-full text-sm">
      <thead><tr className="border-b bg-surface/50 text-left text-xs text-text-secondary"><th className="p-3">信号</th><th className="p-3">智能体</th><th className="p-3">品种/方向</th><th className="p-3">生成时间</th><th className="p-3">有效期</th><th className="p-3">账号执行</th></tr></thead>
      <tbody>{signals.map(({ signal_summary: signal }) => <tr key={signal.signal_id} className="border-b last:border-0">
        <td className="p-3 font-mono text-xs">{signal.signal_id}</td><td className="p-3 font-mono text-xs">{signal.agent_id}</td>
        <td className="p-3">{signal.symbol} · {signal.action}</td><td className="p-3 whitespace-nowrap">{date(signal.generated_at)}</td>
        <td className="p-3 whitespace-nowrap">{date(signal.valid_until)}</td>
        <td className="p-3"><Link className="text-brand underline" to={`/forex/execution-detail/detail?id=${encodeURIComponent(signal.signal_id)}${agentId ? `&agent_id=${encodeURIComponent(agentId)}` : ""}`}>查看逐账号结果</Link></td>
      </tr>)}</tbody>
    </table></div>}
    {cursor && <button type="button" disabled={loading} onClick={() => void loadMore()} className="rounded-lg border px-3 py-2 text-xs disabled:opacity-50">加载更多</button>}
  </div>;
}
